import type { ReactElement } from 'react'
import { AssetPreviewHost, type InsightsService, type PluginId } from '@common/plugin-host'
import fetchService from '../io/api/fetchService'
import { assetPluginRegistry } from './registry'
import { fetchResourceBytes } from './resources'
import useReferencedEntities from './useReferencedEntities'
import serverEntities from './serverEntities'

const insights: InsightsService = (path, init) => fetchService('insights', path, init)

// The console can answer for entities itself, so a previewed plugin's entity-backed controls show
// what they would in the app rather than coming up empty.
const entities = serverEntities()

export const AssetPluginPreview = ({
  pluginId,
  url,
  mimeType,
  entityId,
  editorPreview,
}: {
  pluginId: PluginId
  url: string
  mimeType?: string
  entityId?: string
  editorPreview?: boolean
}): ReactElement => {
  const referencedEntities = useReferencedEntities(url, mimeType)

  return (
    <AssetPreviewHost
      pluginId={pluginId}
      url={url}
      mimeType={mimeType}
      entityId={entityId}
      editorPreview={editorPreview}
      registry={assetPluginRegistry}
      fetchResource={fetchResourceBytes}
      insights={insights}
      entities={entities}
      referencedEntities={referencedEntities}
    />
  )
}

export default AssetPluginPreview
